import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, map } from "rxjs";
import type { Organization, UpdateOrganizationInput } from "src/app/schema";
import { ApiService, CognitoService } from "src/app/services";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class OrganizationService {
	private readonly _httpClient = inject(HttpClient);
	private readonly _api = inject(ApiService);
	private readonly _cognitoService = inject(CognitoService);

	organization: Organization | undefined;

	get organizationId(): string {
		return this._cognitoService.user().organizationId;
	}

	public activeOrganization(): Observable<Organization> {
		if (!this.organizationId) {
			throw new Error("Organization ID is required.");
		}
		return this._httpClient.get<Organization>(
			`${this._api.coreApiEndpoint}/organization/${this.organizationId}`,
		);
	}

	public updateOrganization(
		organizationInput: UpdateOrganizationInput,
	): Observable<Organization> {
		return this._httpClient.put<Organization>(
			`${this._api.coreApiEndpoint}/organization`,
			organizationInput,
		);
	}

	public updateApplicationRequirements(
		organizationInput: UpdateOrganizationInput,
	): Observable<Organization> {
		return this._httpClient.put<Organization>(
			`${this._api.coreApiEndpoint}/organization/application-requirements`,
			organizationInput,
		);
	}

	public stripeAccountLink(): Observable<string> {
		const organizationId = this.organizationId;
		return this._httpClient
			.get<{ link: string }>(
				`${environment.coreEndpoint}/organization/${organizationId}/stripe/account_link`,
			)
			.pipe(map((response) => response.link));
	}
}
